module.exports = __webpack_public_path__ + "static/media/tobin.ae13e11e.png";